import {InjectionToken} from "@angular/core";

export const AUTHGUARD_SERVICE = new InjectionToken('AUTHGUARD_SERVICE');
export const HELPERS_SERVICE = new InjectionToken('HELPERS_SERVICE');
